import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Table from '../common/Table';
import { Link } from 'react-router-dom'
import SearchForm from './SearchForm';

export default class DetailInvoice extends Component {
    /**
     * Init list detail invoice
     */
    constructor(props) {
        super(props)
        this.state = {
            jobApplys: [],
            errors: [],
            startDate: null,
            endDate: null
        }
        this.fireRedirect = this.fireRedirect.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
    }
    
    /**
     * Load detail invoice
     */
    componentWillMount() {
        if (this.props.match.params.hasOwnProperty('id') && this.props.match.params.hasOwnProperty('startDate') && this.props.match.params.hasOwnProperty('endDate')) {
            const clientId = this.props.match.params.id;
            this.state.startDate = this.props.match.params.startDate;
            this.state.endDate = this.props.match.params.endDate;
            axios.get('/api/clients/detail-invoice/'+clientId+'/' + this.state.startDate +'/' + this.state.endDate).then(response => {
                this.setState({
                    jobApplys: response.data
                });
            });
        }
    }
    
    handleRedirect(url) {
        this.setState({
            isShowForm: false
        })
        this.props.history.push(url);
    }
    
    fireRedirect(e) {
        e.preventDefault()
        this.handleRedirect(e.currentTarget.getAttribute('href'));
    }
    
    render() {
        const option = {
            1:{text:'採用',classHTML:'text-primary'},
            2:{text:'不採用',classHTML:'text-pink'},
            9:{text:'応募キャンセル',classHTML:'text-gray'},
            null:{text:'未決定',classHTML:'text-gray'}
        };
        const columns = [
            {name: 'id', title: 'ID', isSort: 1, type: 'text'},
            {name: 'client_first_last_name', title: '依頼者名', isSort: 1, type: 'text', isSearch:true},
            {name: 'staff_first_last_name', title: 'ワーカー名', isSort: 1, type: 'text', isSearch:true},
            {name: 'status', title: 'ステータス', isSort: 1, type: 'text', option:option},
            {name: 'point', title: 'ポイント', isSort: 1, type: 'text'},
            {name: 'created_at', title: '作成日', isSort: 1, type: 'date'},
        ]
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-12">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item"><a onClick={this.fireRedirect} href="/home">ダッシュボード</a></li>
                                <li className="breadcrumb-item active" aria-current="page">請求詳細一覧</li>
                                <Link to={'/clients/invoices/'+this.state.startDate+'/'+this.state.endDate} data-toggle="tooltip" title="一覧へ"><i className="zmdi zmdi-format-list-bulleted"/></Link>
                            </ol>
                        </nav>
                    </div>
		</div>

		<main id="main">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col">
                                            <h4 className="mt-2 mb-0 page-title">請求一覧</h4>
                                        </div>
                                    </div>
                                </div>
                            <Table header={columns} data={this.state.jobApplys} />
                            </div>
                        </div>
                    </div>
		</main>
            </React.Fragment>
        );
    }
}

